module.exports = __webpack_public_path__ + "img/1800espresso_hair.38390811.jpg";